

























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { popup } from '@lx-frontend/cvux'
import { CommonSelectItem } from '../indexType'
import SearchInput from '../../components/SearchInput.vue'

@Component({
  components: {
    popup,
    SearchInput
  }
})
export default class CarTypePopup extends Vue {
  @Prop(Array) readonly list!: CommonSelectItem[];
  @Prop(Number) readonly id!: number;

  keyword = ''

  get options() {
    const { keyword } = this
    if (keyword) {
      return this.list.filter(reason => reason.name.includes(keyword))
    }
    return this.list
  }

  show = false

  handleSelectCar(option: CommonSelectItem) {
    this.$emit('select', option)
    this.changeShow(false)
  }

  changeShow(v:boolean) {
    this.show = v
  }
}
